export default "__VITE_ASSET__JsElfT_V__"